import { useEffect, useState } from "react";
import axios from "axios";
import {
  connectWallet,
  getCurrentWalletConnected //import here
} from "./utils/interact.js";

const Minter = (props) => {

  //State variables
  const [walletAddress, setWallet] = useState("");
  const [status, setStatus] = useState("");
//  const [status_2, setStatus_2] = useState("");
  const [email, setEmail] = useState("");
  const [email_form, setEmail_form] = useState("");
  const [show_email_display, setShow_email_display] = useState(false);

  var comic_count = 0;
  //var comic_links = "(display links here)";
  const [comic_total_display, setComic_total_display] = useState("");
  const [comic_link_1, setComic_link_1] = useState("");
  const [comic_link_2, setComic_link_2] = useState("");
  const [comic_link_3, setComic_link_3] = useState("");
  const [comic_link_4, setComic_link_4] = useState("");
  const [comic_link_5, setComic_link_5] = useState("");

  const [email_display, setEmail_display] = useState("");

  //const [user_ADDRESS, setUser_ADDRESS] = useState("");

//  const [comic_count_display, setComic_count_display] = useState("");

  var display_build = "";
  var comic_count_display = "";

  useEffect(async () => {

    //const token_LIVE_LIST = "0,1,2,1,3,1,6,7,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1";

  const token_LIVE_LIST = get_token_LIVE_LIST();

    var token_LIVE_LIST_array = token_LIVE_LIST.split(',');

      const {address, status} = await getCurrentWalletConnected();
      setWallet(address);
      //setStatus(address);
    //  debugger
      const user_ADDRESS = address;//"0x198f878e70d4c6cdb7a532f69837e996eab02629";//"0x198f878e70d4c6cdb7a532f69837e996eab02629";// LIVE:  address
      //"0x1284552a1f9b75f9a119cd9cfccb1eab208537b6";
      //"0x679d5162BaD71990ABCA0f18095948c12a2756B0";
      //"0x7d1c70b1df2fb5f9111e278cdbcc805babf1b3b2";// juilan
      //"0x7a827fa01ad4985ca7dff695131b28a1600b9130";//aaron
      //"0x198f878e70d4c6cdb7a532f69837e996eab02629";// mr_stereoheadz
      //"0x250425a869d967c8c64b2bc153456f49bba423e3";// anonamister
      // "0xdf9a82dae6939590149550c135e206d8cdc9f19b";//"0xb3c64a8318131802c2d77cceb9af7e5412196397"; // address;//  TODO_---- this is temp test -
    //  setUser_ADDRESS(user_ADDRESS);

      //setWallet(user_ADDRESS);

      // START THE COMIC CHECKER-------
      const { createAlchemyWeb3 } = require("@alch/alchemy-web3");
       const web3 = createAlchemyWeb3("https://eth-mainnet.alchemyapi.io/v2/q3TLJ5wMLz2A-nqs5VCdnowMv5eC9blJ");
       const blockNumber = await web3.eth.getBlockNumber();

       console.log(address)

       if (address == ""){
           //setStatus("Please connect your MetaMask wallet");

           setComic_total_display(
             <div>
               {" "}
                {" "}
              <h2>Please connect your MetaMask wallet</h2>
             </div>
           );
       }

       if (address !== "") {
       //console.log("The latest block number is " + blockNumber);
       const tokenBalances_call = await web3.alchemy.getTokenBalances(address, ["0x1eb7382976077f92cf25c27cc3b900a274fd0012"]);

        //console.log("The tokenBalances_call is " + tokenBalances_call);
        //console.log(tokenBalances_call);
        const tokenBal =  tokenBalances_call.tokenBalances[0].tokenBalance;
        //console.log("The tokenBal is " + tokenBal);
        comic_count = tokenBal;
        // ----- CALL GET TRANSFERS
        //const assetTransfers_call = await web3.alchemy.getAssetTransfers(["0xC73C3D","latest","0xb3c64a8318131802c2d77cceb9af7e5412196397", ["0x1eb7382976077f92cf25c27cc3b900a274fd0012"]]);
        //const assetTransfers_call = await web3.alchemy.getAssetTransfers([{"fromBlock": "0xC73C3D", "toBlock": "latest", "toAddress": "0xb3c64a8318131802c2d77cceb9af7e5412196397","contractAddresses": ["0x1eb7382976077f92cf25c27cc3b900a274fd0012"], "category": ["token"]}]);
        const assetTransfers_call = await web3.alchemy.getAssetTransfers(
            {
              "fromBlock": "0xC44D5E",
              "toBlock": "latest",
              "toAddress": address,
              "contractAddresses": [
                "0x1eb7382976077f92cf25c27cc3b900a274fd0012"
              ],
              "excludeZeroValue": true,
              "maxCount":"0x3e7",
              "category": [
                "token"
              ]
            }
          );

        //console.log("The assetTransfers_call is " + assetTransfers_call);
        //console.log(assetTransfers_call);

        const assetTrans_result_array = assetTransfers_call.transfers;
      //  console.log("The assetTrans_result_array.length is " + assetTrans_result_array.length);
        //console.log("The assetTrans_result_array.asset is " + assetTrans_result_array[0].asset);
        //  setStatus("The latest block number is " + blockNumber+ " -- The tokenBal is " + tokenBal + " -- The assetTrans_result_array.length  is " + assetTrans_result_array.length );

        if(assetTrans_result_array.length==0){
          // THEY DONT OWN ANY --- DISPLAY THAT
          //console.log("YOU DONT OWN ANY COMICS -- will display something");
          setStatus("YOU DONT YOU DONT OWN ANY COMICS -- (display)");
          setComic_link_1("YOU DONT YOU DONT OWN ANY COMICS (NO LINKS TO DISPLAY)");
          setComic_link_2("");
          setComic_link_3("");
          setComic_link_4("");
          setComic_link_5("");

        }else{
            //console.log("COMIC OWNER -- CHECK MORE");

            // CHECK WHAT THEY SOLD
            const assetTransfers_from_array = await web3.alchemy.getAssetTransfers(
                {
                  "fromBlock": "0xC44D5E",
                  "toBlock": "latest",
                  "fromAddress": address,
                  "contractAddresses": [
                    "0x1eb7382976077f92cf25c27cc3b900a274fd0012"
                  ],
                  "excludeZeroValue": true,
                  "category": [
                    "token"
                  ]
                }
              );
            //console.log("The assetTransfers_from_array is " + assetTransfers_from_array);
            //console.log(assetTransfers_from_array);

            const assetTransfers_FROM_transfers = assetTransfers_from_array.transfers;
            //console.log("The assetTransfers_FROM_transfers is " + assetTransfers_FROM_transfers);
          //  console.log("The assetTransfers_FROM_transfers.length is " + assetTransfers_FROM_transfers.length);
            //setStatus("assetTransfers_FROM_transfers.length = " + assetTransfers_FROM_transfers.length+ " -- The tokenBal is " + tokenBal + " -- The assetTrans_result_array.length  is " + assetTrans_result_array.length );

            const token_id_array = [];
            for (let i = 0; i < assetTrans_result_array.length; i++) {
              // CHECK TO make sure they have not been sold (after bought)
              var is_sold = check_if_token_sold(assetTrans_result_array[i],assetTransfers_FROM_transfers);//check_if_token_sold(assetTrans_result_array[i],assetTransfers_FROM_transfers);

              if(is_sold == false){
                // ADD IT TO THE TOKEN LIST:
                   token_id_array.push( parseInt(assetTrans_result_array[i].erc721TokenId, 16)  ); //          TODO --- UNCOMMENT
                  // TEMP FIX (commented above)
                //  token_id_array.push( i+1 );


              }else{
                comic_count = comic_count - 1; // REMOVE IT FROM THE LIST (might make this a little off)
                // maybe add the ~ insert
              }

            }
            //console.log("The token_id_array is " + token_id_array);
            //console.log("The token_id_array.length is " + token_id_array.length);
          //  console.log("The token_id_array[0] is " + token_id_array[0]);
            //console.log("The token_id_array[1] is " + token_id_array[1]);

            // RUN THROUGH THE TOKENS & CHECK
            //--- check TOKEN ID  against   ID_to_TYPE_ARRAY
            //  ---- vars for rarity_level_unlocked = false;
            //------ for each TYPE found the array
            //  ----- set rarity_level_unlocked = true;

            var rarity_level_1_unlocked = false;
            var rarity_level_2_unlocked = false;
            var rarity_level_3_unlocked = false;
            var rarity_level_4_unlocked = false;
            var rarity_level_5_unlocked = false;

            var level_1_count = 0;
            var level_2_count = 0;
            var level_3_count = 0;
            var level_4_count = 0;
            var level_5_count = 0;

            for (let i = 0; i < token_id_array.length; i++) {
              var temp_token_type = check_token_type(token_id_array[i],token_LIVE_LIST_array);

              //console.log("The TOKEN:  " + token_id_array[i]);

              if(temp_token_type == 1){
                rarity_level_1_unlocked = true;
                level_1_count++;
              }else if(temp_token_type == 2){
                rarity_level_2_unlocked = true;
                level_2_count++;
              }else if(temp_token_type == 3){
                rarity_level_3_unlocked = true;
                level_3_count++;
              }else if(temp_token_type == 4){
                rarity_level_4_unlocked = true;
                level_4_count++;
                //console.log("The HOLO:  " + token_id_array[i]);
              }else if(temp_token_type == 5){
                rarity_level_5_unlocked = true;
                level_5_count++;
                //console.log("The PRISM:  " + token_id_array[i]);
              }
            }
            //console.log("The rarity_level_1_unlocked is " + rarity_level_1_unlocked);
          //setStatus("tokenBal is " + tokenBal+" :: rarity_level_1_unlocked = " + rarity_level_1_unlocked+" :: rarity_level_2_unlocked = " + rarity_level_2_unlocked+" :: rarity_level_3_unlocked = " + rarity_level_3_unlocked+" :: rarity_level_4_unlocked = " + rarity_level_4_unlocked+" :: rarity_level_5_unlocked = " + rarity_level_5_unlocked);
          var total_count = level_1_count + level_2_count + level_3_count + level_4_count + level_5_count;

          //  setComic_links(display_build);
          set_main_display(address,total_count,rarity_level_1_unlocked,rarity_level_2_unlocked,rarity_level_3_unlocked,rarity_level_4_unlocked,rarity_level_5_unlocked
, level_1_count, level_2_count, level_3_count, level_4_count, level_5_count);

        //set_comic_count_display(comic_count);

          set_email_display();

          //setEmail_form(  "Hello");



      //var action_type = 1;// 1: log_login  2: save_email  3: view_pdf

      //var

      const json_log = JSON.stringify({ "total_count": total_count,"level_1_count": level_1_count,"level_2_count": level_2_count,"level_3_count": level_3_count,"level_4_count": level_4_count,"level_5_count": level_5_count, "token_id_array": token_id_array});//{ "email": "hello@user.com"});//assetTransfers_call);

      ajax_log_login(address,json_log);
    }

      //var rarity_num = 1;
    //  var comic_PDF_link = ajax_get_pdf_link(user_ADDRESS,rarity_num);
      //console.log("comic_PDF_link = "+comic_PDF_link);


    }// END IF THEY HAVE TOKENS...

        /// --- END COMIC CHECKER


      addWalletListener();
  }, [walletAddress]);

  function addWalletListener() {
    if (window.ethereum) {
      window.ethereum.on("accountsChanged", (accounts) => {
        if (accounts.length > 0) {
          setWallet(accounts[0]);
        //  setStatus("👆🏽 Write a message in the text-field above.");
        } else {
          setWallet("");
          setStatus("🦊 Connect to Metamask using the top right button.");
        }
      });
    } else {
      setStatus(
        <div>
          {" "}
          🦊{" "}
          <a target="_blank" href={`https://metamask.io/download.html`}>
            You must install Metamask, a virtual Ethereum wallet, in your
            browser.
          </a>
        </div>
      );


    }
  }



  function set_main_display(user_ADDRESS,total_count,level_1, level_2, level_3, level_4, level_5, level_1_count, level_2_count, level_3_count, level_4_count, level_5_count) {

      // SET DISPLAYS

      // TODO - display totals
      var add_s = "s";
      if(total_count==1){
        add_s = "";
      }

      setComic_total_display(
        <div>
          {" "}
           {" "}
         <h2>You own {total_count} Comic{add_s}</h2>
        </div>
      );


      if(level_1 == true){
        setComic_link_1(
          <div>
            {" "}
             {" "}
           <div>You own {level_1_count} SILVER</div>
           <button id="readButton_1" onClick={() => onReadButton_1(user_ADDRESS)}>
             VIEW SILVER PDF
           </button>
          </div>
        );
      }
      if(level_2 == true){
        setComic_link_2(
          <div>
            {" "}
             {" "}
           <div>You own {level_2_count} GOLD</div>
           <button id="readButton_2" onClick={() => onReadButton_2(user_ADDRESS)}>
             VIEW GOLD PDF
           </button>
          </div>
        );
      }
      if(level_3 == true){
        setComic_link_3(
          <div>
            {" "}
             {" "}
           <div>You own {level_3_count} CHROMIUM</div>
           <button id="readButton_3" onClick={() => onReadButton_3(user_ADDRESS)}>
             VIEW CHROMIUM PDF
           </button>
          </div>
        );
      }
      if(level_4 == true){
        setComic_link_4(
          <div>
            {" "}
             {" "}
           <div>You own {level_4_count} HOLOFOIL</div>
           <button id="readButton_4" onClick={() => onReadButton_4(user_ADDRESS)}>
             VIEW HOLOFOIL PDF
           </button>
          </div>
        );
      }
      if(level_5 == true){
        setComic_link_5(
          <div>
            {" "}
             {" "}
           <div>You own {level_5_count} PRISM</div>
           <button id="readButton_5" onClick={() => onReadButton_5(user_ADDRESS)}>
             VIEW PRISM PDF
           </button>
          </div>
        );
      }


  }


  function set_email_display(){
      // SET DISPLAYS

      setShow_email_display(true);
/*
        setEmail_form(
         <form action="/action_page.php">
          <h3> Comic Giveaway </h3>
          <input
            type="text"
            placeholder="Enter your email to be entered into a Giveaway of a copy of Issue #1"
            onChange={(event) => setEmail(event.target.value)}
          />
        </form>
        <br></br>
        <button id="emailButton" onClick={() => onEmailPressed()}>
          Submit Email
        </button>
      </div>

      );
*/
  }


  function ajax_log_login(user_ADDRESS,json_log){
    //console.log("FUNCTION: ajax_log_login: user_ADDRESS= "+user_ADDRESS);
    /// SERVER CALLS::
    //const action_type = 1;// 1: log_login  2: save_email  3: view_pdf
    const get_string = "https://boredapecomic.com/bac/dApp/main.php?account="+user_ADDRESS+"&json_log="+json_log+"&action=1";//"https://jsonplaceholder.typicode.com/todos?_page=1&_limit=10";//"https://boredapecomic.com/bac/dApp/main.php?account=".user_ADDRESS;//."&action=".action_type;
    //+"&action=1"
    axios
    .get(get_string)
    .then(response => {
        //setStatus("HELLO?");
        console.log("STATUS: "+response.status);
        console.log(response);
        //setStatus("AJAX BABY in FUNCTION!! LOGIN :: " + response.data.action);
    })
    .catch(function(error) {
        setStatus("ERROR");
        console.log(error);
    });

  }


  function ajax_get_pdf_link(user_ADDRESS,rarity_num){
    console.log("FUNCTION: ajax_get_pdf_link: user_ADDRESS= "+user_ADDRESS+ " :: rarity_num= "+rarity_num);
    var rarity_word = "";
    if(rarity_num==5){
      rarity_word = "pmr";
    }else if(rarity_num==4){
      rarity_word = "hlo";
    }else if(rarity_num==3){
      rarity_word = "cmh";
    }else if(rarity_num==2){
      rarity_word = "gdo";
    }else{
      rarity_word = "sri";
    }

    /// SERVER CALLS::
    //const action_type = 1;// 1: log_login  2: save_email  3: view_pdf
    const get_string = "https://boredapecomic.com/bac/dApp/main.php?account="+user_ADDRESS+"&action=3&r="+rarity_word;//"https://jsonplaceholder.typicode.com/todos?_page=1&_limit=10";//"https://boredapecomic.com/bac/dApp/main.php?account=".user_ADDRESS;//."&action=".action_type;
    //+"&action=1"
    axios
    .get(get_string)
    .then(response => {
        //setStatus("HELLO?");
      //  console.log("STATUS: "+response.status);
        //console.log(response);
        //console.log("AJAX BABY in FUNCTION!!  PDF LINK :: " + response.data.pdf_link);
        //setStatus("AJAX BABY in FUNCTION!!  PDF LINK :: " + response.data.pdf_link);
        const comic_PDF_link = response.data.pdf_link;
      //  console.log("comic_PDF_link = "+comic_PDF_link);
        window.open(comic_PDF_link);

        return response.data.pdf_link;
    })
    .catch(function(error) {
        setStatus("ERROR");
        console.log(error);
    });

  }


 function ajax_save_email(){
   console.log("FUNCTION: ajax_save_email: walletAddress = "+walletAddress+" :: email "+email);
   /// SERVER CALLS::
   //const action_type = 1;// 1: log_login  2: save_email  3: view_pdf
   const get_string = "https://boredapecomic.com/bac/dApp/main.php?account="+walletAddress+"&action=2&email="+email;//"https://jsonplaceholder.typicode.com/todos?_page=1&_limit=10";//"https://boredapecomic.com/bac/dApp/main.php?account=".user_ADDRESS;//."&action=".action_type;
   //+"&action=1"
   axios
   .get(get_string)
   .then(response => {
       //setStatus("HELLO?");
     //  console.log("STATUS: "+response.status);
       //console.log(response);
       //console.log("AJAX BABY in FUNCTION!!  PDF LINK :: " + response.data.pdf_link);
       //setStatus("AJAX BABY in FUNCTION!!  PDF LINK :: " + response.data.pdf_link);
       const email_status = response.data.status;
       console.log("email_status = "+email_status);

       setStatus(
         <div>
           {" "}
           {" "}
           <h4> THANK YOU: You have been entered. </h4>
         </div>
       );

       //return response.data.pdf_link;
   })
   .catch(function(error) {
       setStatus("ERROR");
       console.log(error);
   });


 }




  function check_token_type(token_id,token_LIST_array){
    //  LIST OF TOKENS to check against in top of doc
    var token_id_type = token_LIST_array[token_id-1];
    return token_id_type;
  }

  function check_if_token_sold(assetTrans_single,assetTransfers_FROM_transfers){
    const asset_token_id = parseInt(assetTrans_single.erc721TokenId, 16) ;
    var temp_token_id = 0;
    var is_sold = false;
    //console.log("asset_token_id = " + asset_token_id);
    // check all transfers ---
    for (let i = 0; i < assetTransfers_FROM_transfers.length; i++) {
      temp_token_id = parseInt(assetTransfers_FROM_transfers[i].erc721TokenId, 16)
      //console.log("temp_token_id = " + temp_token_id);
      if(asset_token_id==temp_token_id){
        //console.log("(check_if_token_sold):: FOUND A SOLD: token_id =  "+ asset_token_id);
        //   TODO - might want to check to make sure the sale happened AFTER (using blockNum)
        is_sold = true;
      }
    }
    //console.log("is_sold = " + is_sold);
    return is_sold;
  }


  const connectWalletPressed = async () => {
    const walletResponse = await connectWallet();
    setStatus(walletResponse.status);
    setWallet(walletResponse.address);
  };

  const onEmailPressed = async (user_ADDRESS) => {

    // TODO - SEND TO PHP call - save to DATABASE -
    console.log("CALLED: onEmailPressed");
    //var rarity_num = 1;
    const email_return = await ajax_save_email(user_ADDRESS);
  //  console.log("comic_PDF_link = "+comic_PDF_link);


    //const { success, status } = await mintNFT(url, name, description);
    var success = true;

    //setStatus(status);
    if (success) {
      //setName("SENT");
      //setDescription("");
      //setURL("");
    }
  };


  const onReadButton_1 = async (user_ADDRESS) => {
      console.log("CALLED: onReadButton_1");
      var rarity_num = 1;
      const comic_PDF_link = await ajax_get_pdf_link(user_ADDRESS,rarity_num);
      console.log("comic_PDF_link = "+comic_PDF_link);
  };
  const onReadButton_2 = async (user_ADDRESS) => {
    console.log("CALLED: onReadButton_2");
    var rarity_num = 2;
    const comic_PDF_link = await ajax_get_pdf_link(user_ADDRESS,rarity_num);
    console.log("comic_PDF_link = "+comic_PDF_link);
  };
  const onReadButton_3 = async (user_ADDRESS) => {
    console.log("CALLED: onReadButton_3");
    var rarity_num = 3;
    const comic_PDF_link = await ajax_get_pdf_link(user_ADDRESS,rarity_num);
    console.log("comic_PDF_link = "+comic_PDF_link);
  };
  const onReadButton_4 = async (user_ADDRESS) => {
    console.log("CALLED: onReadButton_4");
    var rarity_num = 4;
    const comic_PDF_link = await ajax_get_pdf_link(user_ADDRESS,rarity_num);
    console.log("comic_PDF_link = "+comic_PDF_link);
  };
  const onReadButton_5 = async (user_ADDRESS) => {
    console.log("CALLED: onReadButton_5");
    var rarity_num = 5;
    const comic_PDF_link = await ajax_get_pdf_link(user_ADDRESS,rarity_num);
    console.log("comic_PDF_link = "+comic_PDF_link);
  };


 function get_token_LIVE_LIST(){

  const token_LIVE_LIST = "1,1,1,4,1,1,1,1,1,1,2,2,1,2,2,1,1,1,3,2,1,1,1,1,2,1,4,1,1,2,1,2,1,2,1,2,3,2,1,2,1,1,2,1,2,1,1,2,1,3,3,1,2,1,1,2,1,2,1,1,2,1,2,2,1,1,1,1,3,1,1,1,1,1,3,1,2,2,1,1,1,1,2,1,1,2,1,1,1,1,1,2,2,2,1,1,3,1,1,1,1,1,1,1,1,1,1,1,2,1,1,1,3,1,1,1,1,1,2,1,1,1,2,2,3,2,2,1,2,1,2,1,1,3,1,2,2,1,1,1,1,2,1,1,1,1,2,2,1,1,1,4,1,1,2,1,2,1,1,1,3,1,1,1,1,1,4,1,1,1,1,1,1,1,1,1,1,2,3,1,1,2,1,2,1,2,1,1,1,2,1,2,3,1,1,1,1,2,1,1,1,1,3,1,1,1,1,1,1,1,1,1,3,2,3,1,1,2,3,1,1,2,1,2,1,1,1,1,2,1,2,1,1,3,1,1,1,2,1,1,1,1,1,2,1,1,2,1,1,1,2,1,2,2,1,1,1,1,2,1,1,1,1,1,1,2,1,2,1,3,1,1,2,1,2,1,2,2,2,1,2,1,1,2,1,1,1,1,1,2,1,1,1,2,2,1,1,1,1,2,1,2,2,1,1,1,1,1,2,1,1,1,3,1,4,1,1,2,1,3,1,1,1,1,1,1,2,2,1,1,2,1,1,3,2,1,2,2,1,3,1,2,1,2,1,2,1,1,1,3,2,2,1,3,1,2,2,1,2,1,1,1,1,3,3,1,2,1,1,1,1,1,1,1,2,2,1,2,3,1,1,1,1,1,1,3,2,1,1,2,1,1,1,2,1,2,1,1,1,3,2,2,1,1,1,1,1,1,2,3,1,1,1,3,1,4,2,1,1,1,2,2,1,1,2,2,1,1,3,1,1,1,1,1,1,1,2,1,1,1,1,1,1,1,1,1,2,1,1,1,3,1,1,2,1,1,1,3,3,1,2,2,1,1,1,1,2,1,1,1,3,1,1,1,3,1,2,1,2,1,2,3,1,1,1,1,1,2,1,2,1,1,1,3,1,1,2,1,1,3,2,2,1,2,2,1,3,2,1,1,3,2,3,4,2,3,2,1,1,1,3,1,1,1,1,1,1,2,1,1,1,1,3,1,2,2,2,3,1,1,1,1,1,1,2,1,1,1,3,1,1,1,1,1,2,1,2,1,1,1,2,1,1,1,1,1,1,1,1,3,1,1,2,1,1,1,2,2,1,2,2,1,1,2,1,1,1,1,2,1,1,2,2,1,1,1,1,1,2,2,1,1,1,1,2,3,1,3,1,1,1,5,2,1,1,2,1,1,2,1,2,1,1,2,1,1,1,2,1,1,1,1,1,1,1,1,1,1,1,2,1,2,1,1,1,1,3,2,1,3,1,2,4,1,2,1,3,1,1,3,1,2,1,1,1,1,2,2,3,2,3,1,2,1,2,1,2,1,1,1,1,1,1,2,1,1,1,1,1,1,1,1,2,1,1,1,1,1,2,1,2,1,1,1,1,3,3,1,1,1,2,1,1,2,1,1,1,3,1,2,2,2,2,3,3,3,1,1,2,1,2,1,1,1,2,1,1,2,1,3,2,1,2,4,1,1,3,2,2,1,2,1,2,1,1,2,1,1,1,1,1,2,2,1,1,1,2,1,2,2,1,1,1,1,2,1,1,1,1,1,1,1,1,1,2,1,2,1,1,1,1,1,1,1,1,1,1,1,2,2,2,1,1,1,3,2,1,1,1,2,3,3,2,1,1,1,1,1,2,1,1,1,1,1,1,1,3,1,2,1,1,1,1,2,1,1,1,1,1,1,1,1,2,1,1,3,2,2,4,1,1,2,1,1,2,1,1,2,1,1,1,1,1,1,1,1,2,1,1,1,1,3,1,2,1,2,3,1,1,1,1,1,1,1,2,1,1,1,1,3,2,2,2,4,4,1,1,1,1,1,1,2,1,2,2,1,1,1,1,1,1,1,2,1,1,3,2,3,1,2,2,2,1,1,1,1,1,1,1,1,2,1,2,1,1,1,1,2,1,2,1,1,2,1,1,3,1,1,1,1,2,2,1,2,1,2,1,1,1,1,1,2,1,2,2,1,3,2,1,2,4,1,2,1,2,1,1,4,1,2,3,1,2,3,1,1,2,2,1,1,2,1,2,2,1,2,1,1,1,1,3,1,2,3,1,1,2,1,1,1,3,1,1,1,1,3,2,3,1,1,2,3,1,1,1,1,2,2,1,2,2,2,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,2,1,1,1,1,1,2,1,1,1,3,2,1,3,3,1,1,1,2,1,2,1,2,4,1,1,1,3,1,2,1,1,1,1,1,1,1,1,1,1,2,2,2,1,2,1,1,1,2,2,2,3,2,1,2,1,1,2,2,1,3,2,1,1,2,2,1,1,1,1,1,2,1,2,1,1,1,1,3,1,1,1,1,2,1,1,2,1,1,1,1,1,1,1,1,2,1,2,2,2,1,2,1,2,1,1,1,1,2,2,1,1,1,2,1,2,1,3,1,2,2,1,1,1,1,1,1,1,3,1,1,1,2,1,4,1,1,2,1,1,1,1,1,1,1,1,3,1,3,2,3,1,1,1,1,2,3,2,2,2,1,2,2,1,4,2,1,1,1,1,1,2,1,3,1,1,1,1,1,1,2,1,2,1,1,1,1,1,1,1,1,2,1,1,1,1,1,1,1,1,2,1,1,1,1,1,1,1,1,1,4,1,1,2,1,3,1,1,1,1,2,2,1,1,2,2,1,2,2,3,1,4,2,2,1,1,3,2,1,1,1,2,1,2,1,2,1,1,1,1,3,1,1,1,3,1,1,1,1,2,1,2,2,4,1,2,1,1,1,1,1,3,1,1,1,1,2,1,1,1,2,2,2,1,2,1,1,2,2,1,2,2,3,1,1,1,2,1,2,2,4,1,1,1,1,1,1,2,1,1,1,4,2,1,2,1,1,1,1,2,1,3,1,1,1,1,1,2,1,1,1,4,1,2,1,1,1,3,1,1,1,1,1,1,1,1,2,1,2,3,1,1,2,2,1,1,1,1,1,1,1,1,1,1,1,1,3,1,1,1,1,3,1,1,1,3,1,1,1,2,1,1,1,1,1,2,1,2,1,1,1,1,1,3,1,1,3,1,1,1,1,1,2,2,1,2,1,3,1,1,1,1,2,1,3,1,2,1,1,1,1,1,1,1,1,2,1,3,1,2,1,1,1,2,1,3,2,3,1,3,1,1,1,1,1,1,1,1,1,2,1,1,2,1,1,1,2,2,1,1,1,1,1,1,1,1,1,1,3,1,1,3,2,1,1,2,1,4,1,2,1,2,1,1,2,1,1,2,1,1,1,2,2,2,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,2,2,2,1,1,2,1,1,2,2,2,1,2,2,1,1,1,2,3,1,1,1,1,4,1,2,2,1,1,1,2,1,1,1,2,3,1,1,2,3,2,2,2,1,1,2,1,2,2,1,1,1,1,2,1,3,2,1,1,2,2,1,1,1,1,1,3,2,1,2,1,1,1,1,1,1,1,1,2,1,1,1,2,1,1,1,2,1,1,1,1,1,1,2,1,1,1,1,1,3,1,1,1,1,1,1,2,2,1,1,2,1,1,2,2,1,2,3,1,1,2,1,1,1,1,1,1,1,2,3,2,2,1,1,1,3,1,1,2,4,1,1,1,1,1,4,2,1,3,1,3,1,1,2,1,1,1,1,2,2,1,1,1,2,1,1,1,1,1,1,2,1,1,1,2,1,1,2,1,3,1,2,3,2,3,1,1,2,3,1,1,3,2,1,2,1,1,1,3,2,1,1,1,2,2,1,1,2,1,1,1,1,2,1,2,1,1,3,1,1,3,1,2,1,1,1,1,2,1,2,2,1,1,1,1,1,1,2,1,1,1,1,1,1,1,1,2,1,1,1,1,1,2,2,3,2,1,2,2,1,1,1,2,1,1,1,1,2,1,1,1,3,1,2,2,2,2,3,1,3,2,1,1,1,1,2,1,2,1,3,1,1,1,2,1,2,1,1,2,3,1,3,1,2,4,2,1,2,1,1,2,2,2,2,2,1,1,2,2,3,3,1,2,1,1,1,1,3,1,3,2,1,1,1,1,1,1,3,1,1,2,1,1,1,4,2,1,1,2,1,1,1,2,2,1,1,2,3,3,1,1,1,1,1,1,2,1,2,1,1,1,1,1,1,1,1,1,1,1,2,1,3,1,1,1,2,1,2,1,2,1,1,3,3,2,3,1,1,1,1,1,1,1,3,1,2,1,3,1,1,1,2,1,1,2,1,1,1,1,1,1,3,1,1,1,2,1,1,2,2,1,1,1,2,2,3,1,2,1,4,1,3,1,1,3,1,1,1,2,1,2,2,1,1,1,3,1,2,1,2,3,1,1,1,2,4,1,1,3,1,2,1,2,1,1,2,1,1,3,1,2,2,1,1,2,1,1,1,1,2,1,1,1,2,1,1,1,3,1,1,2,1,1,1,1,2,4,2,1,1,2,1,1,1,2,2,1,1,1,1,1,3,1,1,2,1,2,2,3,3,1,3,2,1,2,2,1,1,1,2,2,2,1,2,1,1,2,2,1,3,4,2,1,1,2,1,1,2,1,1,1,2,1,2,2,1,2,1,3,3,1,2,1,1,1,2,1,1,1,1,1,1,2,1,1,1,1,3,2,1,1,1,1,2,1,1,1,1,2,1,3,1,1,2,2,1,1,1,3,2,1,1,1,1,2,1,2,1,1,1,1,3,3,1,1,2,2,1,1,1,2,2,1,2,2,1,4,1,1,1,1,1,1,1,2,2,1,1,1,2,1,1,1,1,1,1,2,1,1,1,2,2,2,1,1,2,3,1,1,1,2,1,1,1,1,1,1,1,4,1,1,1,1,2,1,1,1,1,1,1,1,1,1,2,1,1,1,1,1,2,2,1,2,2,2,1,1,1,1,2,2,3,2,1,1,2,1,1,1,1,3,1,1,1,1,1,2,1,1,1,1,1,2,3,2,1,1,2,1,1,1,2,3,1,1,1,1,5,1,1,1,1,3,2,2,1,2,1,2,2,2,1,1,1,2,1,2,1,1,1,1,1,2,1,2,1,1,1,2,2,1,2,2,2,2,1,1,1,1,1,2,1,2,1,1,2,1,1,3,1,1,1,1,1,2,2,1,5,1,1,1,3,3,2,3,2,1,1,1,1,2,2,4,1,2,2,3,2,2,2,2,1,1,1,1,1,1,1,1,1,1,3,1,1,1,2,2,3,1,1,1,2,1,1,1,1,1,1,2,2,1,1,1,1,1,3,3,2,2,3,1,1,3,1,2,2,1,1,1,1,2,1,2,2,1,2,1,1,1,1,1,1,2,1,1,1,2,1,1,3,3,4,1,1,3,2,1,1,1,3,1,1,2,2,1,2,1,2,1,1,1,1,1,1,2,1,2,4,3,3,1,1,2,1,2,1,2,3,2,1,1,1,1,1,1,1,1,2,1,1,2,1,2,1,3,1,1,1,2,1,1,1,1,1,2,1,1,1,1,1,1,2,1,1,1,2,2,1,3,1,3,2,1,3,1,1,1,1,1,1,1,1,2,1,1,1,1,2,3,1,1,1,1,1,2,1,3,2,1,1,2,1,2,1,1,3,1,1,1,1,2,1,2,2,1,1,1,2,1,2,2,2,1,2,1,1,1,2,1,3,1,1,1,1,1,1,1,1,1,2,2,3,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,1,3,1,1,1,1,3,2,1,1,2,1,1,1,1,1,1,1,1,1,1,2,2,2,2,1,2,2,1,2,1,2,3,1,3,1,3,1,1,1,1,2,1,1,1,1,1,1,1,2,1,1,1,1,1,2,1,2,3,1,1,1,2,3,2,1,1,2,1,1,1,1,2,2,2,1,1,1,3,1,1,1,2,2,2,1,1,2,2,1,1,2,2,1,3,1,1,1,2,1,3,1,1,2,1,3,1,1,1,1,1,2,1,1,1,1,1,1,1,1,3,1,1,1,1,1,2,1,1,2,2,3,1,1,2,2,3,1,2,1,2,3,1,1,1,1,1,1,1,1,1,2,3,1,1,2,1,1,2,2,2,1,2,2,2,1,1,1,3,1,1,2,1,3,2,2,3,2,1,2,1,1,1,1,1,2,1,1,1,1,1,1,3,3,2,2,1,2,1,2,1,1,1,1,2,1,2,1,1,2,2,1,1,1,2,1,1,1,1,1,1,1,1,1,1,1,2,1,1,1,1,1,1,2,2,2,2,2,2,1,1,2,3,1,1,1,1,2,2,1,2,2,3,1,1,1,2,2,1,1,1,1,1,1,1,1,1,1,1,1,2,4,1,1,3,1,1,1,1,2,2,1,1,3,1,1,1,1,1,1,2,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,1,2,3,1,2,1,1,3,1,1,2,2,1,2,1,3,2,1,1,1,3,1,1,2,2,3,1,2,1,2,1,1,3,4,1,2,1,1,1,3,2,2,1,2,1,1,2,1,1,1,1,2,3,1,1,3,1,3,1,1,1,1,1,1,2,1,2,1,1,1,2,2,1,2,1,1,1,1,2,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,1,1,2,1,1,2,1,3,1,1,1,1,1,1,1,1,1,1,2,1,2,2,1,1,2,1,4,1,1,2,1,1,1,1,1,1,1,1,1,1,3,3,1,1,1,2,1,2,1,1,1,2,1,1,2,1,1,1,2,3,1,3,1,1,2,2,1,2,1,3,1,2,3,1,1,2,1,1,1,1,2,3,3,1,1,1,1,1,2,4,1,1,1,1,1,3,2,1,1,1,1,1,2,1,1,1,2,2,1,3,1,1,1,1,2,2,1,1,3,1,2,1,1,2,2,1,1,1,1,1,1,1,2,1,1,2,4,3,1,4,2,2,1,1,1,1,1,1,1,1,1,1,1,1,3,1,4,3,2,1,1,1,2,3,1,2,1,1,2,2,1,2,1,1,1,1,1,2,1,2,1,2,1,1,2,1,1,2,1,1,1,1,1,3,1,2,1,1,1,3,1,1,1,2,2,2,1,2,4,3,1,1,1,3,1,2,1,1,1,1,2,1,2,1,4,1,1,1,1,1,2,2,1,1,1,1,3,1,2,2,3,1,1,2,1,4,1,1,2,2,2,1,2,1,1,1,2,1,1,1,2,1,1,1,2,1,1,1,1,2,1,1,4,2,1,2,1,4,1,1,1,2,1,1,1,2,2,2,1,1,2,2,1,1,1,1,1,1,2,1,2,2,1,1,1,2,2,3,3,1,2,1,1,1,1,2,2,1,1,3,1,1,1,1,1,1,2,2,1,1,1,2,1,1,1,1,1,1,1,2,1,1,1,2,1,1,1,2,1,2,1,2,1,1,1,3,3,1,1,3,1,2,1,1,2,2,1,1,1,1,1,3,1,1,1,2,3,2,1,1,1,1,1,2,2,1,1,1,2,1,2,2,1,1,1,1,1,2,1,2,3,1,3,1,1,1,1,1,1,1,1,1,1,1,1,2,2,1,1,1,1,3,2,1,2,2,1,1,1,1,1,1,1,2,2,1,2,1,1,2,1,1,1,1,2,2,1,1,1,1,1,1,1,1,1,1,1,2,1,1,1,4,2,1,2,1,2,2,2,1,1,3,3,1,2,1,2,1,3,1,2,1,1,1,1,1,1,1,1,1,2,1,1,2,1,1,1,2,2,1,1,1,2,1,1,1,1,1,1,1,2,1,1,2,1,1,2,2,2,1,1,2,1,2,1,1,1,1,1,1,4,1,1,1,2,1,2,1,1,1,2,1,2,2,1,1,4,1,1,1,3,1,3,1,2,1,1,1,2,1,2,1,3,1,2,1,4,1,2,1,1,2,1,2,1,1,3,1,1,1,2,1,1,1,1,2,2,2,1,3,2,1,1,1,1,1,2,2,1,1,2,1,1,1,1,1,3,2,2,1,2,1,2,2,3,2,1,1,1,1,2,1,1,1,2,1,4,1,1,1,1,2,1,1,1,1,1,3,1,1,1,1,1,1,1,1,2,1,2,1,1,1,3,1,2,1,2,1,3,2,3,1,1,1,2,1,1,1,2,2,2,1,1,1,3,2,2,1,1,1,1,1,1,1,1,3,2,2,2,2,1,2,2,1,1,2,1,1,2,1,1,2,1,1,1,3,1,1,4,1,1,1,3,1,1,1,3,1,1,2,1,2,1,1,1,1,2,1,3,1,2,2,2,1,2,1,1,2,1,1,1,1,1,2,4,1,1,2,1,2,2,2,1,2,1,1,2,2,1,1,1,1,3,1,1,3,2,1,1,3,5,1,1,1,1,1,1,1,1,2,3,1,3,1,1,1,1,1,1,1,1,1,2,1,1,1,1,2,1,2,1,1,1,1,1,1,1,1,2,1,1,3,1,2,1,1,1,1,2,1,1,2,1,1,2,1,1,1,3,1,1,3,3,1,1,1,3,4,1,2,1,3,1,2,2,1,1,1,2,1,3,2,1,2,2,2,1,1,1,1,1,1,3,1,1,2,3,1,1,1,4,1,2,1,1,1,2,1,3,1,4,1,1,1,1,1,1,1,1,1,2,2,1,3,1,2,2,1,1,1,3,2,1,1,1,1,2,1,3,1,1,3,1,1,1,1,2,3,3,2,1,2,1,1,1,2,1,1,1,3,1,1,1,2,1,2,1,1,3,1,2,1,1,2,1,2,3,1,1,2,1,1,1,1,2,3,3,2,3,1,1,2,2,2,1,1,1,1,1,1,1,1,1,2,1,1,1,1,1,1,2,1,1,1,2,1,1,1,1,1,2,1,1,1,1,2,3,2,1,1,1,2,1,2,3,1,1,1,1,1,2,1,1,1,1,2,2,1,4,4,2,1,1,1,2,2,1,2,1,2,1,2,1,1,1,1,1,1,3,1,1,1,1,2,2,2,2,1,1,1,1,1,1,1,2,1,2,3,1,1,3,1,1,2,2,1,1,2,1,2,1,1,1,1,1,2,1,1,2,1,3,2,1,1,2,3,3,1,2,1,1,1,2,1,1,1,2,2,1,1,1,1,3,4,1,3,1,3,2,2,1,1,1,1,1,2,2,1,1,2,1,1,1,2,1,2,1,2,4,1,1,1,1,1,1,1,1,1,1,1,1,1,1,3,1,1,3,1,2,1,1,1,4,1,1,1,1,2,1,1,1,1,1,1,1,3,2,1,1,2,1,1,2,1,2,2,1,1,2,1,3,2,1,1,1,1,1,1,2,3,2,1,1,2,1,1,1,2,2,1,1,1,2,1,1,2,2,2,1,3,1,2,1,1,1,1,1,2,3,1,1,1,1,1,1,3,1,1,3,3,1,2,1,2,3,2,2,1,1,1,1,1,2,1,2,1,2,2,1,1,1,1,3,1,1,1,1,2,1,1,1,2,1,1,1,2,2,1,2,3,1,1,1,1,1,3,1,2,3,1,1,2,1,1,1,1,1,1,1,1,2,1,2,1,3,1,1,1,1,1,1,3,1,1,1,1,3,1,2,1,2,2,1,2,1,1,1,1,3,1,1,2,1,3,1,2,2,1,1,1,1,1,1,2,1,1,3,1,1,2,1,1,2,1,1,1,2,1,2,2,1,1,1,1,1,1,2,1,1,2,1,1,1,2,1,2,1,1,1,3,1,1,2,2,1,2,3,1,1,1,2,1,1,1,1,1,2,1,1,1,2,3,1,1,1,1,1,2,1,1,1,2,1,1,1,1,1,1,1,1,3,1,3,1,1,1,3,1,1,1,1,1,2,1,1,4,1,4,2,2,4,2,2,2,2,1,1,2,2,1,1,1,2,2,1,1,1,2,1,2,2,1,1,3,1,1,1,1,1,2,1,4,4,3,3,2,1,1,2,2,1,1,1,1,1,2,1,1,2,1,2,1,2,2,2,1,1,1,2,2,3,1,1,1,2,2,1,1,2,3,1,2,1,4,2,1,1,1,2,1,1,3,1,2,1,3,1,2,1,1,1,1,2,1,2,3,2,1,1,3,1,1,1,1,1,2,1,1,1,3,1,2,2,2,1,1,1,1,1,1,1,2,1,3,2,1,1,1,2,2,1,1,2,1,2,1,2,1,2,2,1,2,1,1,2,3,1,2,1,1,1,1,1,1,1,3,1,3,1,1,1,1,1,1,2,1,2,3,2,3,2,1,1,1,2,1,2,2,1,1,1,1,1,1,2,2,1,3,1,1,1,1,2,1,2,2,1,1,1,2,1,1,1,2,1,2,3,2,1,1,3,1,2,1,1,1,1,1,1,2,1,2,3,1,1,1,1,1,1,1,1,1,1,1,3,2,1,1,2,1,2,1,1,1,3,1,1,1,1,1,1,1,2,1,1,1,2,1,3,1,3,1,1,1,1,1,1,1,1,1,2,4,1,1,1,3,1,1,2,1,2,1,1,1,3,1,1,1,2,2,2,1,1,1,1,3,1,1,1,2,2,1,1,2,1,1,1,1,1,3,1,3,1,2,4,3,1,2,1,1,3,1,2,1,3,4,2,1,1,2,1,3,2,2,1,1,1,1,2,2,1,1,1,1,1,1,2,1,1,2,1,1,1,2,1,1,1,1,1,1,2,2,1,1,3,1,1,3,3,1,1,1,1,2,2,2,1,1,4,1,2,1,1,1,1,1,1,1,2,2,4,1,1,1,1,2,2,1,3,1,2,1,2,2,3,3,2,2,1,1,3,2,2,3,1,1,1,1,1,1,2,1,3,1,2,1,1,2,1,1,1,1,1,1,2,2,1,2,1,1,2,1,1,2,2,2,1,1,2,2,1,1,1,1,1,1,1,1,1,1,2,1,1,1,1,2,1,1,1,1,1,1,1,1,1,2,2,1,1,1,1,1,2,2,2,2,2,1,1,1,1,1,2,2,1,2,1,2,1,1,1,1,1,2,2,3,1,1,2,1,1,2,4,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,3,2,2,1,1,1,2,1,1,5,1,2,1,1,2,1,2,1,1,1,1,1,3,2,1,1,1,2,1,1,1,2,2,3,1,1,1,1,2,2,3,1,2,1,1,1,3,1,1,2,2,1,1,1,1,1,2,3,1,1,2,1,2,1,1,2,3,1,3,1,2,2,1,2,1,2,1,1,1,1,1,1,1,1,1,2,1,3,1,1,1,2,2,1,2,1,1,3,1,4,1,1,1,1,2,1,1,1,1,1,1,2,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,3,1,1,1,2,2,1,1,1,1,1,1,2,1,1,1,2,1,1,2,1,1,2,2,4,2,1,3,1,1,1,2,3,1,1,1,1,1,2,3,1,2,2,1,2,1,1,1,1,2,2,1,3,3,1,1,1,2,2,2,3,1,1,2,1,2,1,1,4,1,2,1,1,1,3,1,1,1,1,1,1,2,1,2,1,1,1,1,2,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,1,1,2,1,1,1,1,1,2,3,1,2,1,1,2,1,2,1,2,3,3,2,1,2,1,2,2,1,1,2,2,1,1,3,1,1,2,1,1,1,1,2,1,1,1,1,1,1,1,3,1,1,3,1,2,2,3,3,1,1,2,1,2,1,2,3,1,3,1,1,2,1,1,1,3,1,2,2,1,1,2,1,1,2,2,1,1,1,4,1,2,1,1,3,2,1,1,2,2,2,1,1,1,3,3,1,1,1,2,3,2,1,4,1,1,3,3,1,1,2,1,2,1,3,2,1,2,1,3,1,1,1,1,1,2,3,1,1,1,1,1,4,1,2,1,3,1,3,1,1,3,1,1,3,2,2,1,1,1,1,2,3,1,3,1,1,3,1,1,2,1,1,2,1,1,1,3,1,1,1,1,3,1,1,1,1,1,2,1,2,1,1,1,1,2,1,1,1,2,1,1,1,1,1,2,2,1,2,1,1,1,1,2,1,2,2,2,2,1,1,2,2,3,1,3,1,1,2,1,1,2,1,1,1,1,3,1,1,2,1,1,1,2,1,2,1,1,3,1,1,1,3,1,1,2,1,1,1,1,1,1,1,1,4,1,1,1,1,1,1,1,1,2,2,1,1,1,2,2,1,1,1,1,1,3,1,2,1,1,1,1,1,2,1,1,1,1,2,1,1,2,2,1,1,1,3,1,1,1,1,1,1,2,2,1,2,1,1,1,1,2,2,1,1,1,2,1,1,1,1,1,1,1,1,1,1,1,1,2,1,1,3,1,1,1,1,2,1,1,2,3,2,1,1,1,1,2,1,1,2,1,2,3,1,1,1,2,1,5,1,1,1,1,1,2,3,1,1,1,2,1,1,2,3,1,1,1,2,1,2,1,1,1,1,1,1,1,2,1,2,1,1,1,1,1,1,1,1,1,2,1,2,3,3,1,1,1,3,1,1,2,2,1,1,2,2,1,3,1,2,3,1,1,2,3,1,3,1,2,2,1,1,1,1,1,1,1,3,1,1,1,1,1,1,1,3,3,1,2,1,2,1,1,2,1,1,1,2,2,1,2,1,3,2,1,1,1,1,1,2,1,2,1,1,1,2,1,1,1,1,2,1,1,2,1,1,2,4,2,1,1,1,1,1,2,1,1,1,1,1,1,1,1,3,2,1,1,2,2,1,2,1,1,1,1,1,1,2,1,2,1,1,1,3,2,1,1,1,1,2,1,1,1,1,1,1,3,2,1,1,1,2,1,2,1,1,1,1,1,1,2,1,1,2,2,1,1,2,1,2,1,1,1,2,1,1,1,1,1,1,3,1,1,2,1,1,1,1,3,4,2,2,1,1,2,1,1,1,1,1,3,3,1,1,1,2,1,1,2,1,2,1,1,1,1,1,2,2,2,1,1,2,1,1,1,3,1,2,1,2,2,2,1,2,1,1,1,2,3,2,1,1,1,1,1,1,1,1,1,3,2,2,1,2,2,2,1,1,1,1,2,3,1,1,1,1,1,2,2,1,2,1,2,3,1,1,2,1,1,1,2,1,1,1,1,1,1,1,1,3,3,1,1,1,1,1,1,2,1,1,1,1,1,1,1,1,3,1,1,3,1,2,1,1,2,1,3,2,1,1,2,3,1,1,2,2,1,1,1,2,2,3,1,1,1,1,2,2,1,1,1,1,1,1,3,1,2,1,2,1,2,1,1,1,1,1,1,2,2,1,1,4,1,1,1,1,1,2,1,2,1,1,2,3,3,1,2,1,3,4,1,1,2,1,1,2,1,1,2,1,1,1,3,2,1,2,3,2,2,1,1,1,1,1,4,1,3,1,1,1,1,1,1,2,3,1,1,1,3,1,1,1,2,1,2,3,2,1,1,1,2,2,1,1,1,1,1,1,1,3,1,2,1,1,1,2,1,1,2,1,1,1,1,4,4,2,2,2,1,1,1,1,1,2,1,1,1,1,1,1,2,1,1,3,2,2,1,2,1,2,1,2,1,2,1,1,1,1,1,2,2,1,2,1,2,2,1,3,2,2,1,2,1,1,2,1,2,2,1,1,3,1,1,1,1,2,1,1,1,2,3,1,1,1,2,1,1,3,1,1,1,2,1,2,1,3,2,1,1,1,1,2,2,1,2,1,4,1,2,1,2,3,4,2,2,1,2,2,1,2,1,1,1,3,1,1,1,1,3,1,1,1,1,2,1,1,1,1,1,2,1,2,2,1,2,2,1,2,1,2,1,1,2,2,1,1,1,2,1,1,1,2,2,1,1,1,1,2,1,1,1,1,1,2,2,1,4,2,1,2,1,1,1,3,1,2,2,1,1,1,1,1,1,1,1,2,2,1,1,1,1,4,2,2,1,1,1,1,1,1,1,2,1,1,2,1,1,2,1,1,2,2,3,1,2,2,1,1,1,1,2,1,2,2,1,3,1,1,2,1,1,1,1,1,1,1,3,2,3,1,1,1,3,1,1,1,2,3,1,1,1,1,2,1,2,2,1,1,1,3,2,1,2,1,3,3,2,2,2,1,2,2,3,1,1,1,1,1,1,1,1,3,2,1,1,1,2,1,1,1,1,3,1,3,1,3,1,1,3,2,2,2,1,1,1,1,1,1,1,1,1,1,1,3,1,3,1,2,2,1,2,1,1,2,3,1,1,1,3,2,2,2,1,2,1,1,2,1,2,1,1,1,1,1,4,1,1,2,3,1,1,3,2,1,1,1,1,1,1,1,1,1,1,1,1,1,2,1,1,1,1,2,1,1,1,2,1,1,1,1,1,3,1,2,1,1,3,1,2,2,1,1,1,1,2,1,1,2,1,1,1,1,2,1,1,3,1,2,3,3,1,1,2,3,3,1,1,2,2,1,3,2,1,1,2,2,1,3,1,1,1,2,2,3,1,3,2,2,1,2,2,2,1,1,3,1,1,1,1,1,2,2,1,1,2,2,1,2,1,3,1,1,1,1,1,1,3,1,1,1,3,2,2,1,2,1,1,4,2,1,1,3,1,2,3,1,1,1,1,1,1,1,1,1,1,2,1,1,3,1,2,2,1,1,2,4,2,1,1,1,1,1,1,1,1,1,1,1,3,1,1,1,1,2,1,1,2,1,2,2,1,1,1,2,1,1,1,1,1,1,2,4,1,1,1,2,2,1,1,2,1,1,2,1,1,1,1,3,1,1,1,1,1,1,1,1,2,1,4,1,3,1,2,1,1,1,1,2,1,3,1,1,2,1,2,2,1,2,1,1,1,1,2,1,3,2,1,1,1,2,1,2,2,2,1,1,2,1,1,1,1,1,1,1,1,2,2,2,1,1,2,1,2,1,1,2,1,1,1,1,1,2,1,1,2,2,2,2,1,1,2,1,1,2,1,3,1,3,1,1,1,2,1,3,2,1,2,2,1,1,2,2,1,1,1,2,1,2,3,1,2,1,1,1,1,2,1,1,3,2,2,1,1,1,1,1,1,1,1,1,2,2,1,4,1,2,2,1,1,1,1,2,2,1,4,2,1,2,1,1,2,1,1,1,2,1,1,1,1,1,2,1,3,2,1,3,2,1,1,1,1,1,1,1,1,2,2,1,1,1,1,1,2,1,3,1,2,1,2,2,1,1,2,1,3,1,3,1,1,2,1,1,1,1,1,1,1,1,1,1,2,2,1,1,1,1,1,1,1,1,1,1,1,1,1,2,1,1,1,2,1,2,1,1,1,2,2,1,2,2,1,1,2,2,1,1,1,1,2,1,2,3,1,1,2,1,1,1,2,1,2,1,3,1,1,2,1,3,1,2,2,1,1,1,1,1,2,1,2,1,1,1,2,1,1,1,1,1,1,1,2,1,2,1,1,1,1,2,1,2,1,1,1,2,1,2,2,1,1,1,2,2,4,1,1,1,2,1,3,1,1,1,1,1,3,1,1,1,1,1,1,2,1,1,1,1,1,1,1,2,1,3,3,1,2,1,1,1,2,1,1,2,3,1,2,1,2,3,1,1,2,1,1,3,3,2,1,1,2,1,2,1,1,1,1,1,1,1,2,2,2,1,2,2,1,2,1,2,1,1,1,1,1,1,1,1,1,2,2,2,1,1,1,2,1,1,1,1,1,2,1,1,1,1,2,4,1,2,1,1,1,1,1,2,5,1,1,1,2,1,1,1,1,1,1,1,1,1,1,2,2,2,2,4,3,1,1,1,1,2,3,1,1,1,1,1,1,1,2,1,1,1,1,1,3,4,2,1,1,1,4,1,1,1,2,1,3,1,1,1,2,1,2,1,1,2,3,1,2,1,1,1,2,1,2,2,2,2,1,1,2,1,1,1,1,1,1,1,2,1,1,1,1,1,3,1,1,1,1,3,1,1,1,1,1,1,1,1,1,3,3,1,1,2,2,1,3,2,2,1,1,1,2,1,1,3,3,1,1,1,1,1,1,1,1,2,1,1,1,1,1,1,2,1,1,1,1,3,2,2,1,1,1,4,2,3,1,1,4,2,1,1,1,2,1,3,2,1,2,1,1,1,1,3,2,1,1,1,1,1,1,1,1,3,1,1,1,1,1,1,4,1,1,1,1,1,1,1,3,1,2,2,1,1,1,1,1,1,1,3,2,1,1,3,2,1,2,2,1,2,2,1,1,1,1,2,1,2,1,1,3,1,1,1,1,1,1,2,1,1,2,1,2,1,1,2,2,2,2,2,2,2,1,1,3,2,1,1,1,1,1,1,1,1,1,1,2,1,1,1,1,1,2,2,1,2,2,2,1,2,1,1,1,1,1,1,2,1,1,1,2,2,2,2,2,1,1,3,1,2,1,2,1,1,3,1,1,1,2,1,2,1,1,1,1,1,1,1,3,2,2,1,1,3,1,1,3,1,1,1,3,1,2,3,1,1,1,3,2,1,3,1,2,1,1,1,1,1,1,2,4,1,1,2,1,2,1,1,1,2,1,1,2,2,1,2,1,2,2,1,1,1,2,1,1,1,1,1,1,1,1,1,2,1,1,1,1,1,1,1,3,1,1,1,1,1,1,1,2,2,1,2,2,1,1,1,1,1,1,1,1,1,2,1,1,1,1,1,1,1,1,1,1,1,1,1,3,2,1,2,2,1,1,1,2,1,2,2,1,1,1,1,1,1,1,1,1,1,1,1,2,1,2,1,1,1,3,1,2,1,3,1,3,2,1,1,1,1,2,2,1,1,1,3,1,1,1,2,1,1,2,1,1,2,3,1,3,1,1,2,1,2,1,1,3,1,1,2,2,2,1,1,1,2,3,1,1,2,1,1,3,4,2,1,3,1,2,1,1,3,2,1,1,1,1,1,1,4,3,1,2,1,1,1,1,4,1,1,1,1,1,2,2,1,1,1,1,1,1,3,2,1,1,2,1,3,2,3,4,1,1,1,1,1,3,1,1,1,3,2,1,2,3,3,1,1,1,1,1,1,2,2,3,1,1,2,1,4,2,1,2,2,1,2,2,2,1,1,1,2,1,1,1,2,1,1,1,1,3,1,1,1,1,2,1,3,1,1,3,2,1,3,1,1,1,1,1,1,1,2,2,1,2,1,1,1,1,2,1,1,1,1,3,1,1,1,2,2,1,2,2,1,1,2,2,2,4,1,2,1,1,3,1,1,2,1,2,1,1,1,1,1,2,2,3,1,2,2,1,2,3,2,2,1,1,1,1,2,1,2,1,1,1,3,1,3,2,1,1,1,2,1,3,2,1,2,1,1,1,2,1,1,1,1,1,1,1,1,1,1,2,3,1,2,2,2,1,3,1,1,1,1,1,2,2,1,1,2,1,1,1,1,1,1,1,1,3,2,1,2,1,2,1,1,1,1,1,1,1,2,1,2,1,1,1,2,1,1,1,3,1,1,2,3,1,1,1,1,1,1,2,2,1,1,1,1,1,1,2,2,1,1,1,1,4,2,3,2,1,1,2,1,1,3,1,2,1,2,1,1,2,1,2,1,1,2,3,1,1,1,1,1,1,1,1,1,1,2,1,1,1,2,1,1,2,2,1,1,1,1,1,2,2,1,2,1,2,1,1,1,1,1,1,2,1,3,2,1,1,2,2,1,1,1,1,1,1,2,1,2,1,2,1,1,1,3,1,3,1,1,1,1,2,2,1,1,1,3,2,1,1,2,1,2,2,1,1,1,1,1,1,1,1,1,1,1,2,1,2,1,2,1,1,2,3,1,1,2,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,1,1,2,2,1,2,4,3,2,5,4,1,1,2,1,2,2,1,1,1,1,3,2,2,1,1,1,1,1,1,2,1,1,2,2,1,2,1,3,1,2,4,1,1,1,1,1,1,1,1,1,1,3,1,2,1,4,1,2,1,1,1,1,4,2,1,1,1,1,1,1,2,1,1,2,1,2,2,1,1,3,2,1,2,1,1,1,1,1,1,1,2,1,1,1,1,2,1,1,2,1,1,3,2,1,1,1,3,2,3,1,2,1,2,1,2,1,1,1,3,4,2,2,1,2,2,2,3,3,1,1,1,1,1,1,2,1,1,1,3,1,1,1,2,1,1,1,2,1,2,1,3,2,1,2,2,2,2,2,4,1,3,1,1,2,1,2,1,1,1,1,1,1,1,2,2,1,1,1,1,1,3,2,1,3,1,1,3,1,1,1,1,1,2,1,1,1,1,2,1,1,2,1,3,2,2,2,1,1,1,1,1,1,1,1,1,3,3,1,2,3,1,2,2,1,1,1,1,1,1,2,1,2,1,1,1,2,3,1,1,2,1,1,2,1,2,2,2,3,1,1,1,1,1,1,3,2,2,2,1,1,1,1,1,1,1,1,1,1,1,2,1,1,3,1,2,3,1,2,1,1,1,1,2,1,2,1,1,1,1,2,3,1,2,1,2,1,1,2,1,1,1,1,1,1,2,3,2,1,1,1,1,2,1,2,3,2,1,1,1,1,1,1,1,1,1,2,1,1,2,1,1,1,1,1,1,1,1,1,1,2,1,1,2,1,2,1,2,1,1,2,1,1,1,1,1,2,2,2,1,1,1,1,2,1,3,3,1,1,1,1,1,2,1,2,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,1,1,4,1,1,1,1,2,1,1,1,1,2,2,2,2,1,1,2,1,1,1,1,2,1,1,1,2,2,2,3,2,1,1,1,1,2,1,2,2,1,3,1,1,1,3,1,1,1,1,1,1,2,2,1,1,2,2,4,1,1,1,2,1,1,2,2,2,3,1,1,1,1,2,2,2,1,1,1,1,1,1,2,1,1,1,1,1,1,2,2,1,2,1,1,2,1,1,1,1,1,3,1,1,1,1,1,1,1,1,1,1,3,1,2,1,1,3,2,3,2,1,1,1,2,1,1,2,1,2,1,1,3,1,1,1,1,1,2,1,2,2,1,2,1,2,2,1,1,1,2,1,3,1,1,1,2,1,1,1,1,1,2,1,1,1,2,3,2,1,1,1,1,1,1,1,1,1,1,3,1,1,2,1,2,1,2,2,2,3,1,1,1,1,2,1,1,1,1,1,1,2,1,2,3,3,1,1,1,1,2,2,2,1,1,1,1,1,1,1,3,2,1,1,1,1,1,1,1,1,2,1,3,1,4,1,2,1,1,1,1,1,1,2,2,4,1,2,1,1,2,2,1,1,3,1,1,1,1,1,1,2,1,1,1,1,1,1,3,1,2,1,1,1,1,1,1,2,2,3,1,1,2,1,1,1,1,2,1,1,1,1,1,1,1,2,2,1,1,1,1,4,1,1,1,1,1,3,1,2,1,3,1,1,1,1,1,2,2,2,1,2,1,1,1,2,1,1,1,1,2,2,1,2,2,1,1,1,3,1,1,1,1,1,1,1,1,3,3,3,2,1,2,1,1,1,2,1,1,1,4,4,1,1,1,2,2,1,1,1,3,1,1,1,1,2,2,2,2,1,3,1,2,1,1,2,2,2,1,1,1,1,1,1,2,3,2,2,1,3,1,1,2,1,1,2,1,1,3,2,2,1,2,1,2,1,3,1,1,1,1,2,1,3,1,1,1,2,1,1,2,1,1,2,1,1,1,1,3,2,1,2,3,3,1,1,1,2,1,1,1,4,1,1,1,1,1,2,2,1,1,2,1,1,1,1,1,1,1,1,3,1,1,2,3,1,2,1,1,1,1,1,1,3,2,2,1,1,2,3,1,2,2,1,1,1,1,2,1,1,1,1,1,1,1,1,3,1,1,1,1,1,3,1,1,2,1,1,2,3,2,1,1,3,3,1,2,1,3,1,2,1,2,1,2,2,1,2,3,1,1,1,1,1,1,1,3,1,2,1,1,3,1,2,1,1,2,1,2,2,1,3,1,1,3,3,1,1,1,2,2,1,2,1,1,2,1,1,1,1,1,2,1,1,1,1,2,2,5,1,2,1,2,1,1,2,3,2,2,1,1,1,1,1,1,1,1,1,1,1,1,2,1,2,2,1,3,1,2,1,1,1,2,1,1,1,1,2,2,2,1,3,1,1,2,3,1,1,3,4,1,1,1,2,1,1,3,1,1,2,3,2,2,3,1,1,2,2,1,2,1,1,1,1,1,1,1,1,4,1,1,1,3,1,1,1,1,1,2,3,3,2,1,1,1,1,2,3,4,1,1,1,1,2,1,1,3,1,2,3,1,1,1,2,2,1,4,1,2,2,1,2,1,2,2,2,1,1,2,1,2,1,1,1,1,1,1,2,1,2,1,3,1,2,1,2,1,1,1,1,2,1,1,1,2,1,3,1,2,1,1,2,1,2,1,2,1,1,1,3,1,1,2,1,1,1,1,1,1,1,1,2,1,1,2,1,1,1,1,1,1,1,2,2,2,2,3,1,4,1,1,1,3,1,2,2,4,1,1,1,1,1,2,1,1,2,2,2,3,3,1,2,2,1,1,1,3,1,1,1,1,1,1,1,2,1,2,2,1,1,1,2,1,1,1,1,1,1,1,3,2,2,3,3,2,2,1,1,1,2,1,1,2,1,2,1,1,1,2,1,2,1,2,1,1,1,2,1,1,1,1,2,1,1,1,4,1,1,2,1,2,2,1,1,1,1,1,1,1,3,1,2,1,2,2,3,1,2,1,1,1,1,1,2,2,3,2,1,1,1,3,2,2,1,1,1,1,1,1,1,2,1,3,1,1,1,1,1,1,1,1,2,1,1,1,1,1,1,1,2,1,1,2,2,1,2,1,1,1,2,2,1,1,1,2,1,3,3,2,4,1,2,2,2,2,2,1,2,1,1,1,1,1,1,2,1,3,1,1,1,1,2,1,3,1,4,1,3,2,1,1,1,2,1,2,1,1,1,2,1,1,1,1,2,1,1,1,1,1,1,1,3,1,1,1,1,1,1,3,3,2,2,1,1,3,1,1,1,2,1,1,1,1,1,1,2,1,1,1,1,1,1,2,1,1,1,1,1,1,3,1,3,1,2,4,1,1,1,1,1,2,1,1,2,1,2,2,2,1,1,1,1,1,2,2,3,1,1,3,3,1,2,1,1,1,1,2,1,1,2,1,1,1,1,1,1,3,1,1,1,1,2,1,1,3,1,4,1,1,1,1,2,1,1,1,2,1,1,1,1,2,3,2,3,1,1,2,1,3,2,1,3,2,1,2,2,2,1,1,1,3,1,1,2,2,2,3,2,1,1,1,1,1,2,3,1,1,1,2,2,2,2,2,1,2,2,1,3,1,1,1,1,3,1,1,1,1,1,1,1,2,2,1,2,2,1,1,1,3,3,1,1,3,2,1,1,3,1,2,1,1,1,1,1,2,2,2,1,3,1,1,1,1,1,1,1,1,2,1,1,1,1,1,1,1,1,2,2,1,1,2,1,1,2,2,1,3,1,2,2,2,1,1,1,1,1,1,2,2,3,1,1,2,2,1,1,1,2,1,3,2,1,2,2,1,2,1,3,1,2,1,2,1,1,3,1,1,3,1,1,1,1,3,1,1,4,1,2,1,1,1,1,1,1,1,1,1,1,1,1,2,1,1,1,1,1,3,2,3,1,1,1,1,2,2,2,3,1,1,1,2,2,1,1,1,1,1,1,1,1,1,1,1,1,1,2,1,3,1,1,3,2,2,1,1,1,2,1,2,1,1,1,1,1,2,2,2,1,2,2,1,1,1,1,1,1,2,1,1,1,2,1,2,2,1,1,1,2,3,1,3,1,1,1,2,1,1,1,1,2,1,2,3,1,2,1,1,2,1,2,3,2,1,1,1,3,1,1,1,2,1,1,2,1,2,1,1,3,1,2,1,1,2,1,2,1,1,2,1,4,1,2,2,1,2,1,1,2,1,1,1,1,2,4,1,1,2,1,1,2,1,3,1,1,1,2,1,1,1,4,1,1,2,1,1,2,2,3,2,1,2,1,1,2,3,1,1,4,1,2,1,1,2,1,1,1,1,1,1,1,1,1,1,1,2,2,1,2,3,1,1,1,1,3,2,2,3,1,2,1,2,2,2,1,1,1,2,2,1,3,2,2,1,1,1,1,3,1,1,1,1,1,2,1,2,1,2,1,1,1,1,1,2,1,1,2,1,1,3,3,1,1,1,1,3,1,2,2,1,2,3,1,1,2,1,1,5,2,1,1,1,1,1,1,1,1,1,1,1,1,1,4,2,1,1,1,2,1,1,1,1,1,1,3,3,1,1,1,3,1,1,1,1,1,1,1,1,2,2,1,2";
   return token_LIVE_LIST;
 }



  return (
    <div className="Minter">
      <button id="walletButton" onClick={connectWalletPressed}>
        {walletAddress.length > 0 ? (
          "Connected: " +
          String(walletAddress).substring(0, 6) +
          "..." +
          String(walletAddress).substring(38)
        ) : (
          <span>Connect Wallet</span>
        )}
      </button>

      <br></br>
      <h1 id="title">Bored Ape Comic: Issue #1</h1>
      <hr></hr>
      <div id="comic_total_display">
        {comic_total_display}
      </div>
      <br></br>
      <div id="comic_link_1">
        {comic_link_1}
      </div>
      <br></br>
      <div id="comic_link_2">
        {comic_link_2}
      </div>
      <br></br>
      <div id="comic_link_3">
        {comic_link_3}
      </div>
      <br></br>
      <div id="comic_link_4">
        {comic_link_4}
      </div>
      <br></br>
      <div id="comic_link_5">
        {comic_link_5}
      </div>
      <br></br>

      <hr></hr>

      <br></br>
      <div id="email_form">

      { show_email_display ? emailDisplay(
          (event) => setEmail(event.target.value),
          () => {
            onEmailPressed()
            setShow_email_display(false)
          }
        ) : undefined
      }

    </div>

        <div id="status">
          {status}
        </div>


    </div>
  );
};

export const emailDisplay = (onChange, onClick) => {
  return (
    <div>
      <form action="/action_page.php">
        <h3> Comic Giveaway </h3>
        <input
          type="text"
          placeholder="Enter your email for a chance to win a GOLD copy of Issue #1"
          onChange={onChange}
        />
      </form>
      <br></br>
      <button id="emailButton" onClick={onClick}>
        Submit Email
      </button>

    </div>
  )
}

export default Minter;
